
precision highp float;
precision highp int;
precision highp sampler2D;

uniform vec2 direction;
uniform int kernelSize;
uniform sampler2D imgToBlur;

in vec2 vUv;
out vec4 fragColor;

vec4 blur5(sampler2D image, vec2 uv, vec2 resolution, vec2 direction) {
  vec4 color = vec4(0.0);
  vec2 off1 = vec2(1.3333333333333333) * direction;
  color += texture(image, uv) * 0.29411764705882354;
  color += texture(image, uv + (off1 / resolution)) * 0.35294117647058826;
  color += texture(image, uv - (off1 / resolution)) * 0.35294117647058826;
  return color; 
}

vec4 blur9(sampler2D image, vec2 uv, vec2 resolution, vec2 direction) {
  vec4 color = vec4(0.0);
  vec2 off1 = vec2(1.3846153846) * direction;
  vec2 off2 = vec2(3.2307692308) * direction;
  color += texture(image, uv) * 0.2270270270;
  color += texture(image, uv + (off1 / resolution)) * 0.3162162162;
  color += texture(image, uv - (off1 / resolution)) * 0.3162162162;
  color += texture(image, uv + (off2 / resolution)) * 0.0702702703;
  color += texture(image, uv - (off2 / resolution)) * 0.0702702703;
  return color;
}

vec4 blur13(sampler2D image, vec2 uv, vec2 resolution, vec2 direction) {
  vec4 color = vec4(0.0);
  vec2 off1 = vec2(1.411764705882353) * direction;
  vec2 off2 = vec2(3.2941176470588234) * direction;
  vec2 off3 = vec2(5.176470588235294) * direction;
  color += texture(image, uv) * 0.1964825501511404;
  color += texture(image, uv + (off1 / resolution)) * 0.2969069646728344;
  color += texture(image, uv - (off1 / resolution)) * 0.2969069646728344;
  color += texture(image, uv + (off2 / resolution)) * 0.09447039785044732;
  color += texture(image, uv - (off2 / resolution)) * 0.09447039785044732;
  color += texture(image, uv + (off3 / resolution)) * 0.010381362401148057;
  color += texture(image, uv - (off3 / resolution)) * 0.010381362401148057;
  return color;
}

vec4 blur19(sampler2D image, vec2 uv, vec2 resolution, vec2 direction) {
  vec4 color = vec4(0.0);
  vec2 off1 = vec2(1.434782608695652) * direction;
  vec2 off2 = vec2(3.347826086956522) * direction;
  vec2 off3 = vec2(5.260869565217392) * direction;
  vec2 off4 = vec2(7.173913043478261) * direction;


  color += texture(image, uv) * 0.16818993967466953;
  color += texture(image, uv + (off1 / resolution)) * 0.2727695816518679;
  color += texture(image, uv - (off1 / resolution)) * 0.2727695816518679;

  color += texture(image, uv + (off2 / resolution)) * 0.11690124927937194;
  color += texture(image, uv - (off2 / resolution)) * 0.11690124927937194;

  color += texture(image, uv + (off3 / resolution)) * 0.024067904263400105;
  color += texture(image, uv - (off3 / resolution)) * 0.024067904263400105;

  color += texture(image, uv + (off4 / resolution)) * 0.0021112196722280793;
  color += texture(image, uv - (off4 / resolution)) * 0.0021112196722280793;
  return color;
}


void main() {
  vec4 color = vec4(1., 0, 0, 1.);
  vec2 textureResolution = vec2(textureSize(imgToBlur, 0));

  if (kernelSize == 5) {
    color = blur5(imgToBlur, vUv, textureResolution, direction);
  } else if (kernelSize == 9) {
    color = blur9(imgToBlur, vUv, textureResolution, direction);
  } else if (kernelSize == 13) {
    color = blur13(imgToBlur, vUv, textureResolution, direction);
  } else if (kernelSize == 19) {
    color = blur19(imgToBlur, vUv, textureResolution, direction);
  }

  fragColor = color;

  // if (direction.x < 0.5) {
  //   fragColor = vec4(1., 0, 0, 1.);
  // } else {
  //   fragColor = vec4(0., 1, 0, 1.);
  // }


  // if (direction.x < 0.5) {
  //   fragColor *= 100.;
  // } 
}